invHdApp.controller('SupplierController',
  ['$scope', 'Supplier', '$location', 'FileUploader', '$localStorage', '$filter', '$routeParams', '$http', 'Filter', '$timeout',
    function ($scope, Supplier, $location, FileUploader, $localStorage, $filter, $routeParams, $http, Filter, $timeout) {
      $scope.address = 0;
      $scope.deleted = [];
      $scope.update = {};
      $scope.edit = [];
      $scope.newAdress = {};
      var componentForm = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        administrative_area_level_2: 'short_name',
        country: 'long_name',
        postal_code: 'short_name'
      };
      var mapping = {
        street_number: 'number',
        route: 'street',
        locality: 'state',
        administrative_area_level_1: 'city',
        administrative_area_level_2: 'district',
        country: 'country',
        postal_code: 'zip'
      };

      $scope.selectAll = function (select) {
        if (select) {
          $scope.deleted = [];
          for (let i = 0; i < $scope.data.customers.data.length; i++) {
            $scope.deleted.push($scope.data.customers.data[i].id);
          }
        } else {
          $scope.deleted = [];
        }
      };

      $scope.$on('new_data', function () {
        $scope.newCustomer();
        $('#newCustomer').modal('show');
      }, true);

      $scope.$on('edit_data', function (event, data) {
        $scope.show(data);
      }, true);

      $scope.filterProp = [];

      $scope.filterData = {
        customers: [],
        workers: [],
        workSteps: [],
        page: 1,
        created_at: {
          startDate: null,
          endDate: null
        },
        scheduled_time: {
          startDate: null,
          endDate: null
        }
      }

      $scope.addFilterProps = function (item) {
        if ($scope.filterProp.indexOf(item) === -1)
          $scope.filterProp.push(item);
        else {
          var index = $scope.filterProp.indexOf(item);
          $scope.filterProp.splice(index, 1);
          $scope.filterData[item] = "";
          if ($scope.filterProp.length == 0) {
            $scope.filter('clear');
          }
        }
      }

      $scope.getPage = function (page) {
        $scope.filterData.page = page;
        $scope.filter();
      }

      $scope.sort = function (field, sort) {
        $scope.filterData.field = field;
        $scope.filterData.sort = sort;
        $scope.filter();
      }

      $scope.filter = function (type) {
        if (type == 'clear') {
          $scope.filterData = {
            customers: [],
            companies: [],
            workers: [],
            workSteps: [],
            page: 1,
            created_at: {
              startDate: null,
              endDate: null
            },
            scheduled_time: {
              startDate: null,
              endDate: null
            }
          };
          $scope.filterProp = [];
        }
        $scope.init();
      };

      $scope.refreshData = function(page) {
        $scope.init();
      };

      $scope.$on('refresh_data', function () {
        console.log('refreshing customers...')
        $scope.init();
      }, true);

      $scope.init = function () {
        Supplier.init($scope.filterData).success(function (data, status, headers, config) {
          $scope.data = data;
          if (typeof $scope.filterData.filterProp !== 'undefined') {
            $scope.filterProp = [];
            if (angular.isArray($scope.filterData.filterProp)) {
              for (var i = $scope.filterData.filterProp.length - 1; i >= 0; i--) {
                $scope.filterProp.push($scope.filterData.filterProp[i])
              }
            } else {
              $scope.filterProp.push($scope.filterData.filterProp);
            }
          }
        });
      };

      $scope.newCustomer = function () {
        Supplier.newCustomer().success(function (data, status, headers, config) {
          $scope.fields = data.fields;
          $scope.workTypes = data.workTypes;
          $scope.stations = data.stations;
          $scope.permissionSteps = [
            {
              id: 'created',
              name: 'Kargo Oluşturma',
              sms: false,
              email: false
            }
          ];

          $scope.customer = {
            prices: []
          }
          $scope.workTypes.forEach(element => {
            $scope.customer.prices.push({
              work_type: element.id,
              type: 'weight'
            })
          });
        });
      };

      var logo = $scope.logo = new FileUploader({
        url: '/api/upload-customer-logo',
        headers: { 'X-CSRF-TOKEN': CSRF_TOKEN },
        autoUpload: true
      });

      logo.filters.push({
        name: 'formatFilter',
        fn: function (item /*{File|FileLikeObject}*/, options) {
          var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
          return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
        }
      });

      logo.onAfterAddingFile = function (fileItem) {
        $scope.proccessProfile = true;
        $scope.pending = true;
      };

      logo.onCompleteItem = function (item, response, status, headers) {
        $scope.proccessProfile = false;
        $scope.customer.logo = response.file;
        if (response.status == 'success')
          $scope.pending = false;
      }

      $scope.getAddress = function (gAddress) {
        if (typeof gAddress.latitude !== 'undefined') {
          var location = new google.maps.LatLng(gAddress.latitude, gAddress.longitude);
          // $scope.map.setCenter(location);
          // $scope.marker.setDuration(1000);
          // $scope.marker.setEasing("swing");
          // $scope.marker.setPosition(location);
          $scope.customer.latitude = gAddress.latitude;
          $scope.customer.longitude = gAddress.longitude;
          $scope.customer.city = gAddress.city;
          $scope.customer.state = gAddress.state;
          var address = ''
          if (gAddress.street) {
            address += gAddress.street + ' '
          }
          if (gAddress.number) {
            address += gAddress.number
          }
          $scope.customer.zipcode = gAddress.zipcode ? gAddress.zipcode : gAddress.zip;
          $scope.customer.address = address;
          $scope.states.forEach(element => {
            if (element.abbreviation == gAddress.city) {
              $scope.customer.state = element.name;
              return true;
            }
          });
        }
      }

      $scope.saveCustomer = function (customer) {
        Supplier.saveCustomer(customer).success(function (data, status, headers, config) {
          Messenger().post(data.message);
          // $location.path('musteri-yonetimi');
          $('#newCustomer').modal('hide');
          $scope.init()
        }).error(function (data) {
          Messenger().post({ message: data.message, type: "error" });
        });
      };

      $scope.delete = function (type) {
        if (type == 'set') {
          $('#delete').modal('show');
        } else if (type == 'delete') {
          var txt;
          var r = confirm("Silmek istediğinize emin misiniz ? Bu işlem geri alınamaz bir işlemdir!");
          if (r == true) {
            Supplier.deleteCustomer($scope.deleted).success(function (data, status, headers, config) {
              Messenger().post(data.message);
              $scope.init();

              $scope.deleted = [];
            }).error(function (data) {
              Messenger().post({ message: data.message, type: "error" });
            });
          }
        } else if (type == 'all') {
          var txt;
          var r = confirm("Tüm müşterileri silmek istediğinize emin misiniz ? Bu işlem geri alınamaz bir işlemdir!");
          if (r == true) {
            Supplier.deleteCustomer({ type: 'all' }).success(function (data, status, headers, config) {
              Messenger().post(data.message);
              $scope.init();

              $scope.deleted = [];
            }).error(function (data) {
              Messenger().post({ message: data.message, type: "error" });
            });
          }
        }
      };

      $scope.updateCustomer = function () {
        $scope.customer.permissionSteps = $scope.permissionSteps;
        Supplier.updateCustomer($scope.customer).success(function (data, status, headers, config) {
          Messenger().post(data.message);
          $('#editSupplier').modal('hide');
          $scope.getSupplierDetail($scope.customer.id);
        }).error(function (data) {
          Messenger().post({ message: data.message, type: "error" });
        })
      };

      $scope.show = function (data) {
        Supplier.show(data.id).success(function (data, status, headers, config) {
          $scope.customer = data.customer;
          $scope.chart = data.chart;
          $scope.fields = data.fields;
          $scope.workTypes = data.workTypes;
          $scope.stations = data.stations;
          $scope.permissionSteps = [
            {
              id: 'created',
              name: 'Kargo Oluşturma',
              sms: false,
              email: false
            }
          ];

          $('#editSupplier').modal('show');
        });
      }

      $scope.toggleSelection = function toggleSelection(id) {
        var idx = $scope.deleted.indexOf(id);
        if (idx > -1) {
          $scope.deleted.splice(idx, 1);
        }
        else {
          $scope.deleted.push(id);
        }
      };


      $scope.uploadme;

      $scope.uploadImageCustomer = function (customer) {
        $scope.upload = true;
        var fd = new FormData();
        var imgBlob = dataURItoBlob(customer.imageUp);
        fd.append('file', imgBlob);
        fd.append('customer', customer.id);
        $http.post(
          'api/upload-image-customer',
          fd,
          {
            transformRequest: angular.identity,
            headers: {
              'Content-Type': undefined,
              'X-CSRF-TOKEN': CSRF_TOKEN
            }
          }
        )
          .success(function (response) {
            $scope.customer.logo = response.logo;
            console.log($scope.customer);
          });
      };

      function dataURItoBlob(dataURI) {
        var binary = atob(dataURI.split(',')[1]);
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        var array = [];
        for (var i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {
          type: mimeString
        });
      };

      $scope.toggleStatus = function toggleStatus(event) {

        if (event.target.checked) {

          $scope.deleted = [];

          for (var i = 0; i < $scope.data.customers.data.length; i++) {

            $scope.deleted.push($scope.data.customers.data[i].id);
          }
        } else {

          $scope.deleted = [];

        }
      };

      $scope.addPrice = function (workType) {
        $scope.customer.prices.push({
          min_weight: null,
          type: 'weight',
          work_type: workType
        });
      }

      $scope.removePrice = function (item) {
        var index = $scope.customer.prices.findIndex(function (elm) {
          return elm.$$hashKey == item.$$hashKey
        })

        console.log(index)

        $scope.customer.prices.splice(index, 1);

      }

      $scope.getCustomers = function() {
          Filter.getCustomers().then(function(response) {
              $scope.filterCustomers = response.data.customers;
              $('.selectpicker').selectpicker('refresh');
          });
      };

      $scope.getCompanies = function() {
          Filter.getCompanies().then(function(response) {
              $scope.filterCompanies = response.data.companies;
              $('.selectpicker').selectpicker('refresh');
          });
      };

      $scope.getWorkers = function() {
          Filter.getWorkers().then(function(response) {
              $scope.filterWorkers = response.data.workers;
              $('.selectpicker').selectpicker('refresh');
          });
      };

      $scope.getStations = function() {
          Filter.getStations().then(function(response) {
              $scope.filterStations = response.data.stations;
              $('.selectpicker').selectpicker('refresh');
          });
      };

      $scope.getCities = function() {
          Filter.getCities().then(function(response) {
              $scope.filterCities = response.data.cities;
              $('.selectpicker').selectpicker('refresh');
          });
      };
    }
  ]);